import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Icon } from 'semantic-ui-react'
import useResponsive from '@hooks/useResponsive'
import cn from 'classnames'
import './styles.scss'

const Action = ({
  onClick,
  disabled,
  content,
  direction,
  primary,
  inverted,
  className,
  showIconOnResponsive
}) => {
  const { t } = useTranslation()
  const isResponsive = useResponsive(520)
  const animated = !isResponsive

  return (
    <Button
      animated={animated}
      onClick={onClick}
      disabled={disabled}
      primary={primary}
      inverted={inverted}
      className={cn('survey-button lg survey-button-action', className)}
    >
      <Button.Content visible>
        {t(content)}{' '}
        {isResponsive && showIconOnResponsive && (
          <Icon
            name={`arrow ${direction}`}
            className='survey-button-action__icon-not-animated'
          />
        )}
      </Button.Content>
      {animated && (
        <Button.Content hidden>
          <Icon name={`arrow ${direction}`} fitted />
        </Button.Content>
      )}
    </Button>
  )
}

export default Action
